import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import getSsn from "../../common/Ssn";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getDate, getDobDate, getMonthAndYear } from "../../common/DisplayDate";

class DriverLiencesDetails extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    const { isSilverReport } = this.props;
    const records = isSilverReport
      ? this.props.node
      : _.get(
          props.reportData,
          "personReport.compReportResponse[0].individual[0].AKAs[0].identity"
        );
    if (records !== undefined && records.length > 0) {
      _.forEach(records, (record, recIndex) => {
        const licenses = isSilverReport
          ? _.get(record, "driversLicenses[0].driversLicense")
          : _.get(record, "driverLicenses[0].driverLicense");
        if (licenses !== undefined && licenses.length > 0) {
          _.forEach(licenses, (license, index) => {
            const issueDate = getDate(_.get(license, "issueDate[0]"));
            const DOB = isSilverReport
              ? getMonthAndYear(_.get(license, "DOB[0]"))
              : getDobDate(_.get(license, "DOB[0]"), {
                  userAccount: this.props.userAccount,
                });
            const origExpDate = getDate(_.get(license, "expirationDate[0]"));
            const physicalData = [];
            const race = _.get(license, "race[0]._", "");
            if (race !== "") {
              physicalData.push(
                <span key={`phy_data_${index}`}>Race: {race} </span>
              );
            }
            const height = _.get(license, "height[0]._", "");
            if (height !== "") {
              const heightText = `${height.substring(0, 1)}ft${height.substring(
                1,
                3
              )}in `;
              physicalData.push(
                <span key={`height_${index}`}>Height: {heightText} </span>
              );
            }
            const weight = _.get(license, "weight[0]._", "");
            if (weight !== "") {
              physicalData.push(
                <span key={`weight_${index}`}>Weight: {weight}lb </span>
              );
            }
            const eyeColor = _.get(license, "eyeColor[0]._", "");
            if (eyeColor !== "") {
              physicalData.push(
                <span key={`eye_color_${index}`}>
                  <nobr>Eye Color:</nobr> {eyeColor}
                </span>
              );
            }
            const hairColor = _.get(license, "weight[0]._", "");
            if (weight !== "") {
              physicalData.push(
                <span key={`hair_color_${index}`}>
                  <nobr>Hair Color:</nobr> {hairColor}
                </span>
              );
            }
            const restrictions = _.get(
              license,
              "restrictionsDetail[0].restriction"
            );
            let restrictionText = "";
            if (restrictions !== undefined && restrictions.length > 0) {
              _.forEach(restrictions, (restriction) => {
                restrictionText = `${restrictionText} ${_.get(
                  restriction,
                  "[0]._",
                  ""
                )}`;
              });
            }
            rows.push(
              <Table.Row key={`rep_liens_row_3_${recIndex}_${index}`}>
                <Table.Cell>
                  <Table
                    className={`${index % 2 === 1 ? "table-odd-child" : ""}`}
                  >
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={2} className="text-bold">
                          Name:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {isSilverReport
                            ? getPersonName(
                                _.get(record, "name[0].firstName[0]._", ""),
                                "",
                                _.get(record, "name[0].lastName[0]._", ""),
                                props
                              )
                            : getPersonName(
                                _.get(record, "name[0].first[0]._", ""),
                                "",
                                _.get(record, "name[0].last[0]._", ""),
                                props
                              )}
                        </Table.Cell>
                        <Table.Cell width={2} className="text-bold">
                          Record Type:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {_.get(license, "history[0]._", "")}
                        </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={2} className="text-bold">
                          Address:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {license.address && license.address.length > 0 && (
                            <Address
                              addressNode={license.address[0]}
                              {...this.props}
                            />
                          )}
                        </Table.Cell>

                        <Table.Cell width={2} className="text-bold">
                          License Class/Type:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {_.get(license, "licenseClass[0]._", "")}{" "}
                          {_.get(license, "licenseType[0]._", "")}{" "}
                          {_.get(license, "status[0]._", "")}
                        </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={2} className="text-bold">
                          Date Of Birth:
                        </Table.Cell>
                        <Table.Cell width={6}> {DOB} </Table.Cell>
                        <Table.Cell width={2} className="text-bold">
                          License State:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {isSilverReport
                            ? _.get(license, "outOfStateIssuer[0]._")
                            : _.get(license, "originStateName[0]._")}
                        </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={2} className="text-bold">
                          SSN:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {!isSilverReport &&
                            getSsn(_.get(license, "SSN[0]._"), this.props)}
                        </Table.Cell>
                        <Table.Cell width={2} className="text-bold">
                          Issued Date:
                        </Table.Cell>
                        <Table.Cell width={6}> {issueDate} </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={2} className="text-bold">
                          Gender:
                        </Table.Cell>
                        <Table.Cell width={6}>
                          {isSilverReport
                            ? _.get(license, "gender[0]._")
                            : _.get(license, "sex[0]._")}
                        </Table.Cell>
                        <Table.Cell width={2} className="text-bold">
                          Expiration Date:
                        </Table.Cell>
                        <Table.Cell width={6}> {origExpDate} </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={2} className="text-bold">
                          Physical Data:
                        </Table.Cell>
                        <Table.Cell width={6}>{physicalData}</Table.Cell>
                        {restrictionText !== "" ? (
                          <Table.Cell width={2}>Restrictions:</Table.Cell>
                        ) : (
                          <Table.Cell width={2} />
                        )}
                        {restrictionText !== "" ? (
                          <Table.Cell width={2}>{restrictionText}</Table.Cell>
                        ) : (
                          <Table.Cell width={6} />
                        )}
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          });
        }
      });
      recCount = rows.length;
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Driver Licences"}
        rows={this.state.rows}
      />
    );
  }
}

export default DriverLiencesDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/DriverLiencesDetails.js